import { render } from "./info-project.vue?vue&type=template&id=516a548a&scoped=true&ts=true"
import script from "./info-project.vue?vue&type=script&lang=ts"
export * from "./info-project.vue?vue&type=script&lang=ts"

import "./info-project.vue?vue&type=style&index=0&id=516a548a&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516a548a"]])

export default __exports__